var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"incubadora"},[_c('Header'),_c('About'),_c('Etapas'),_c('Anio2020'),_c('Contratos'),_c('Register')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }